import styled from 'styled-components'
import { theme } from '../styles/GlobalStyle'

const ContactStyle = styled.div`
  .phone {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 40px 20px;
    font-size: 24px;
    font-weight: 300;
    line-height: 1.5;
    color: ${theme.grey3};
    text-align: center;
  }

  .phone span {
    color: ${theme.green};
  }
  .phone a,
  .phone span {
    color: ${theme.green};
    margin: 0 10px;
  }

  .phone.phone-border {
    border-top: 1px solid ${theme.grey2};
  }

  @media (max-width: 767px) {
    .phone {
      flex-direction: column;
    }
  }
`

export default ContactStyle
